export default __webpack_public_path__ + "static/media/motherboard.b6363c07.jpg";